import { createReducer } from 'redux-starter-kit';
import { ContingentApi } from '../../_helpers/service';
import { handleError } from '../../utils/handleError';
import Dict from '../../utils/Dict';
import Notice from '../../utils/Notice';
import i18next from 'i18next';
import lodash from 'lodash';
import { NCALayerSign } from '../../components/NCALayer/NCALayerSign';
import PassportForm from '../../passport/FormData/PassportForm';
import moment from 'moment';
import paths from './../../_helpers/paths';
import { checkTypePhoto } from '../../utils/checkTypePhoto';
import _ from 'lodash';
import { handleTaskError } from '../MyTaskPage/TaskPage/handleTaskError';

export const contingentPassportModule = 'contingentPassport';
const LOADING = `${contingentPassportModule}/LOADING`;
const SET_DATA = `${contingentPassportModule}/SET_DATA`;
const CLEAR_STATE = `${contingentPassportModule}/CLEAR_STATE`;
const LOADING_APPROVE = `${contingentPassportModule}/LOADING_APPROVE`;
const LOADING_REVOKE = `${contingentPassportModule}/LOADING_REVOKE`;
const LOADING_SAVE = `${contingentPassportModule}/LOADING_SAVE`;
const SET_META = `${contingentPassportModule}/SET_META`;
const LOADING_GROUPS_CHILD = `${contingentPassportModule}/LOADING_GROUPS_CHILD`;
const SET_GROUPS = `${contingentPassportModule}/SET_GROUPS`;
const LOADING_RETIREMENT = `${contingentPassportModule}/LOADING_RETIREMENT`;
const LOADING_ENROLL = `${contingentPassportModule}/LOADING_ENROLL`;
const LOADING_REJECT = `${contingentPassportModule}/LOADING_REJECT`;


/**
 * Reducer
 */

const initialState = {
  loading: false,
  loadingApprove: false,
  loadingRevoke: false,
  loadingGroups: false,
  loadingRetirement: false,
  loadingEnroll: false,
  loadingSave: false,
  loadingReject: false,
  info: {},
  data: {},
  meta: {},
  groups: [],
  contingentStatus: null
};

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.payload;
  },
  [SET_DATA]: (state, action) => {
    const { meta, data, info } = action.payload;
    if (meta) state.meta = meta;
    if (info) state.info = info;
    if (data) state.data = data;
  },
  [LOADING_APPROVE]: (state, action) => {
    state.loadingApprove = action.payload;
  },
  [SET_META]: (state, action) => {
    state.meta = action.payload;
  },
  [LOADING_REVOKE]: (state, action) => {
    state.loadingRevoke = action.payload;
  },
  [LOADING_GROUPS_CHILD]: (state, action) => {
    state.loadingGroups = action.payload;
  },
  [SET_GROUPS]: (state, action) => {
    state.groups = action.payload;
  },
  [LOADING_RETIREMENT]: (state, action) => {
    state.loadingRetirement = action.payload;
  },
  [LOADING_ENROLL]: (state, action) => {
    state.loadingEnroll = action.payload;
  },
  [LOADING_SAVE]: (state, action) => {
    state.loadingSave = action.payload;
  },
  [LOADING_REJECT]: (state, action) => {
    state.loadingReject = action.payload;
  },
  [CLEAR_STATE]: state => {
    return { ...initialState, invalidPassport: state.invalidPassport };
  }
});

/**
 * Actions
 */

export const loadData = id => async dispatch => {
  try {
    dispatch({ type: LOADING, payload: true });
    if (id) {
      const { data } = await ContingentApi.getContingentItem(id);
      const { data: meta } = await ContingentApi.loadMeta(data.metadataKey);
      if (data.directionId) {
        const { data: direction } = await ContingentApi.getDirection(data.directionId);
        data['hasPrivilege'] = direction.hasPrivilege;
      }
      dispatch(setData({ meta, data }));
    }
  } catch (error) {
    handleError(error, i18next.t('contingentPassport_errorLoad'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};

export const getMeta = () => async dispatch => {
  try {
    dispatch({ type: LOADING, payload: true });
    let data = {
      metadataKey: 'form_contingent_do_child'
    };
    const { data: meta } = await ContingentApi.loadMeta(data.metadataKey);
    dispatch({ type: SET_META, payload: meta });
  } catch (error) {
    handleError(error, i18next.t('contingentPassport_errorLoadMeta'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};

export const clearState = () => ({ type: CLEAR_STATE });

export const approveContingent = (
  id,
  confBenefit,
  closeModal,
  contingentId,
  values = {}
) => async dispatch => {
  try {
    dispatch({ type: LOADING_APPROVE, payload: true });
    const response = await ContingentApi.getSignString({ id, confBenefit, ...values });
    const signature = await NCALayerSign(response.data.result.signature);
    if (signature) {
      await ContingentApi.approve(id, { id, signature, confBenefit, ...values });
      Notice.success(i18next.t('contingentPassport_approveSuccess'));
      closeModal();
    }
    dispatch(loadData(contingentId));
  } catch (error) {
    const errorCode = _.get(error, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('signTask_errorSignatureValidation'));
    } else {
      handleTaskError(error, i18next.t('contingentPassport_approveError'));
    }
  } finally {
    dispatch({ type: LOADING_APPROVE, payload: false });
  }
};

export const retirementContingent = (
  id,
  values,
  closeModal,
  directionId,
  info
) => async dispatch => {
  try {
    dispatch({ type: LOADING_APPROVE, payload: true });
    const response = await ContingentApi.getSignatureContingent({
      contingentType: 'DO_CHILD',
      ...values,
      dateDropout: info.dateDropout,
      dropoutReason: info.dropoutReason
    });
    const signature = await NCALayerSign(response.data.result.signature);
    if (signature) {
      await ContingentApi.retirement(id, {
        signature,
        ...values,
        dateDropout: info.dateDropout,
        dropoutReason: info.dropoutReason
      });
      dispatch(loadData(id));
      Notice.success(i18next.t('contingentPassport_retirementSuccess'));
      closeModal();
    }
  } catch (error) {
    if (
      error?.response?.data?.errors[0]?.code ===
      'error.runtime_user_must_sing_own_signature'
    ) {
      Notice.error(i18next.t('signTask_errorSignatureValidation'));
    } else if (
      error?.response?.data?.errors[0]?.code ===
      'error.date_dropout_is_before_enrolled_date'
    ) {
      Notice.error(i18next.t('contingentPassport_dateDropoutBeforeEnrolled'));
    } else if (
      error?.response?.data?.errors[0]?.code ===
      'error.date_dropout_is_after_current_date'
    ) {
      Notice.error(i18next.t('contingentPassport_dateDropoutAfterEnrolled'));
    } else {
      handleError(error, i18next.t('contingentPassport_retirementError'));
    }
  } finally {
    dispatch({ type: LOADING_APPROVE, payload: false });
  }
};

export const revokeContingent = (
  id,
  values,
  closeModal,
  contingentId
) => async dispatch => {
  try {
    dispatch({ type: LOADING_REVOKE, payload: true });
    const response = await ContingentApi.getSignString({ id, ...values });
    const signature = await NCALayerSign(response.data.result.signature);
    if (signature) {
      await ContingentApi.revoke(id, { id, signature, ...values });
      dispatch(loadData(contingentId));
      Notice.success(i18next.t('contingentPassport_revokeSuccess'));
      closeModal();
    }
  } catch (error) {
    const errorCode = _.get(error, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('signTask_errorSignatureValidation'));
    } else {
      handleTaskError(error, i18next.t('contingentPassport_revokeError'));
    }
  } finally {
    dispatch({ type: LOADING_REVOKE, payload: false });
  }
};

export const enrollContingent = (
  id,
  values,
  groupId,
  closeModal,
  setIsError,
  directionId,
  voucherId,
  contingentType
) => async dispatch => {
  try {
    dispatch({ type: LOADING_ENROLL, payload: true });
    const response = await ContingentApi.getSignatureContingent({
      directionId: directionId,
      voucherId: voucherId,
      id: id,
      contingentType: contingentType,
      ...values
    });
    const signature = await NCALayerSign(response.data.result.signature);
    if (signature) {
      await ContingentApi.enroll(id, { childGroupId: groupId, signature, ...values });
      dispatch(loadData(id));
      Notice.success(i18next.t('contingentPassport_enrollSuccess'));
      closeModal();
    }
    setIsError(false);
  } catch (error) {
    const errorCode = _.get(error, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('signTask_errorSignatureValidation'));
    } else if (errorCode === 'error.file_must_be_present') {
      Notice.error(i18next.t('contingentPassport_enrollFileMustBePresent'));
    } else {
      handleTaskError(error, i18next.t('contingentPassport_enrollError'));
    }
  } finally {
    dispatch({ type: LOADING_ENROLL, payload: false });
  }
};

export const getGroupsChild = id => async dispatch => {
  try {
    dispatch({ type: LOADING_GROUPS_CHILD, payload: true });
    let { data } = await ContingentApi.getGroupsChild(id);
    if (data.status === 'SUCCESS') {
      dispatch({ type: SET_GROUPS, payload: data.result });
    }
  } catch (error) {
    handleError(error, i18next.t('contingentPassport_revokeError'));
  } finally {
    dispatch({ type: LOADING_GROUPS_CHILD, payload: false });
  }
};

export const setData = ({ meta, data }) => async dispatch => {
  const dictDirectionStatus = await Dict.itemsObject('gu_status_direction');
  let statusDirection = lodash.get(
    data,
    'questionnaire.questionCodeToAnswers.status_direction.values[0].value',
    null
  );
  data['statusDirection'] = statusDirection;

  const statusVoucher = data['voucherStatus'];
  if (data['voucherStatus']) {
    data.questionnaire.questionCodeToAnswers['status_voucher'] = {
      values: [
        {
          value: data['voucherStatus']
        }
      ]
    };
  }

  const info = {
    id: data.id,
    iin: data.iin,
    directionId: data.directionId,
    voucherId: data.voucherId,
    contingentStatus: data.contingentStatus,
    statusDirection: dictDirectionStatus[statusDirection] || {},
    statusVoucher: statusVoucher
  };
  dispatch({ type: SET_DATA, payload: { meta, data, info } });
  dispatch({ type: LOADING, payload: false });
};

export const checkChangeChildPhoto = ({
  element,
  changeChildPhoto,
  setUpdatedAt
}) => async dispatch => {
  try {
    dispatch({ type: LOADING_SAVE, payload: true });
    if (changeChildPhoto && element.id) {
      const { data } = await ContingentApi.canChangeChildPhoto(element.id);
      if (data.status === 'SUCCESS') {
        if (data.result.canChange) {
          dispatch(savePassport({ element, setUpdatedAt }));
        } else {
          Notice.error(i18next.t('contingentPassport_photoUpdatedMonth'));
        }
      }
    } else {
      dispatch(savePassport({ element, setUpdatedAt }));
    }
  } catch (error) {
    handleError(error, i18next.t('contingentPassport_errorVerifyPhotos'));
  } finally {
    dispatch({ type: LOADING_SAVE, payload: false });
  }
};
export const savePassport = ({ element, setUpdatedAt }) => async dispatch => {
  try {
    dispatch({ type: LOADING_SAVE, payload: true });
    const { data } = await ContingentApi.savePassport({ params: element });
    setUpdatedAt(
      _.get(
        data.entity?.['questionnaire'].questionCodeToAnswers,
        'Foto.status.stamp.updatedAt',
        null
      )
    );
    Notice.success(i18next.t('contingentPassport_saveFormSuccess'));
  } catch (error) {
    handleError(error, i18next.t('contingentPassport_errorSaveForm'));
  } finally {
    dispatch({ type: LOADING_SAVE, payload: false });
  }
};

export const addContingent = ({ values, history, close, groupId }) => async dispatch => {
  try {
    dispatch({ type: LOADING_SAVE, payload: true });
    let photo = PassportForm.values['form_contingent_do_child.Foto'];
    if (checkTypePhoto(photo.file)) {
      Notice.error(i18next.t('contingentPassport_photoTypeSaveFormatNot'));
      close();
    } else {
      const response = await ContingentApi.getSignatureContingent({
        contingentType: 'DO_CHILD',
        ...values
      });
      const signature = await NCALayerSign(response.data.result.signature);
      if (signature) {
        let iin = PassportForm.values['form_contingent_do_child.child_iin'];
        let params = {
          signature,
          iin: iin,
          contingentType: 'DO_CHILD',
          contingentStatus: 'ENROLLED',
          isChangingGroup: true,
          serviceProviderId: null,
          childGroupId: groupId,
          enrolledDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          contingentChanges: [...values['contingentChanges']]
        };
        await ContingentApi.addContingent(params);
        history.replace(paths.contingentEnrolledPage);
        Notice.success(i18next.t('contingentPassport_enrollSuccess'));
        close();
      }
    }
  } catch (error) {
    let iin = PassportForm.values['form_contingent_do_child.child_iin'];
    if (
      error?.response?.data?.errors[0]?.code ===
      'error.runtime_user_must_sing_own_signature'
    ) {
      Notice.error(i18next.t('signTask_errorSignatureValidation'));
      close();
    } else if (
      error?.response?.data?.errors[0]?.code ===
      'error.creating_already_enrolled_contingent'
    ) {
      Notice.error(i18next.t('contingentPassport_errorApplicantContingent', { iin }));
      close();
    } else if (
      error?.response?.data?.errors[0]?.code ===
      'error.creating_already_applicant_contingent'
    ) {
      Notice.error(i18next.t('contingentPassport_errorCreatingApplicantContingent'));
      close();
    } else if (
      error?.response?.data?.errors[0]?.code ===
      'error.creating_already_queued_contingent'
    ) {
      Notice.error(i18next.t('contingentPassport_errorCreatingQueuedContingent'));
    } else {
      handleError(error, i18next.t('contingentPassport_enrollError'));
    }
  } finally {
    dispatch({ type: LOADING_SAVE, payload: false });
  }
};

export const getGroups = info => async dispatch => {
  try {
    dispatch({ type: LOADING_GROUPS_CHILD, payload: true });
    const { data } = await ContingentApi.getGroups(info);
    if (data.status === 'SUCCESS') {
      dispatch({ type: SET_GROUPS, payload: data.result });
    }
  } catch (error) {
    handleError(error, i18next.t('contingentPassport_errorLoadGroup'));
  } finally {
    dispatch({ type: LOADING_GROUPS_CHILD, payload: false });
  }
};

export const rejectContingent = (id,history) => async dispatch => {
  try {
    dispatch({ type: LOADING_REJECT, payload: true });

    const response = await ContingentApi.getSignatureContingent({
      contingentType: 'DO_CHILD',
      contingentChanges: []
    });
    const signature = await NCALayerSign(response.data.result.signature);

    if (signature) {
      await ContingentApi.rejectContingent({
        id,
        signature
      });
      Notice.success(i18next.t('contingentPassport_rejectSuccess'));
      history.goBack()
    }
  } catch (error) {
    const errorCode = _.get(error, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(i18next.t('signTask_errorSignatureValidation'));
    } else {
      handleError(error, i18next.t('contingentPassport_rejectError'));
    }
  } finally {
    dispatch({ type: LOADING_REJECT, payload: false });
  }
};
